const EventsTabs = () => {
  const eventsTabsTitles = [...document.querySelectorAll(".events-tabs__tab-title")];
  const eventsTabsContents = [...document.querySelectorAll(".events-tabs__tab-content")];

  if (eventsTabsTitles.length > 0 && eventsTabsContents.length > 0) {
    eventsTabsTitles[0].classList.add("active");
    eventsTabsContents[0].classList.add("active");

    eventsTabsTitles.forEach((title, index) => {
      title.addEventListener("click", () => {
        eventsTabsTitles.forEach((t) => t.classList.remove("active"));
        eventsTabsContents.forEach((c) => c.classList.remove("active"));

        title.classList.add("active");
        eventsTabsContents[index].classList.add("active");
      });
    });
  }
};

export default EventsTabs;
